// Version : 0.0.5
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// LastAdd : getGSTTypeListResponse is added
// MODFIED DATA : 04-09-2025
import { docodeHexResponse } from '../../../_common/common.utils';
import GSTTypeActionTypes from './gstType.types';

const INITIAL_STATE = {
	// ADD GST TYPE DETAILS
	addGSTTypeDetailsResponse: null,
	// UPDATE GST TYPE DETAILS
	updateGSTTypeDetailsResponse: null,
	// GET GST TYPE LIST
	getGSTTypeListResponse: null,
	getGSTTypeListArr: [],
	// FETCH GST TYPE DETAILS
	fetchGSTTypeDetailsResponse: null,
	fetchGSTTypeDetailsArr: [],
	// DELETE GST TYPE DETAILS
	deleteGSTTypeDetailsResponse: null,
};

const gstTypeReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD GST TYPE DETAILS START *********************** */
		case GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_SUCCESS:
			return { ...state, addGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_FAILURE:
			return { ...state, addGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, addGSTTypeDetailsResponse: null };
		/** ***************** ADD GST TYPE DETAILS END *********************** */

		/** ***************** UPDATE GST TYPE DETAILS START *********************** */
		case GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_SUCCESS:
			return { ...state, updateGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_FAILURE:
			return { ...state, updateGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateGSTTypeDetailsResponse: null };
		/** ***************** UPDATE GST TYPE DETAILS END *********************** */

		/** ***************** GET GST TYPE LIST START *********************** */
		case GSTTypeActionTypes.GET_GST_TYPE_LIST_SUCCESS:
			return {
				...state,
				getGSTTypeListResponse: action.payload,
				getGSTTypeListArr: docodeHexResponse(action.payload, 'GetGSTTypeListKey'),
			};

		case GSTTypeActionTypes.GET_GST_TYPE_LIST_FAILURE:
			return { ...state, getGSTTypeListResponse: action.payload };

		case GSTTypeActionTypes.GET_GST_TYPE_LIST_RESPONSE_CHANGED:
			return { ...state, getGSTTypeListResponse: null };
		/** ***************** GET GST TYPE LIST END *********************** */

		/** ***************** FETCH GST TYPE DETAILS START *********************** */
		case GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_SUCCESS:
			return {
				...state,
				fetchGSTTypeDetailsResponse: action.payload,
				fetchGSTTypeDetailsArr: docodeHexResponse(action.payload, 'FetchGSTTypeDetailsKey'),
			};

		case GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_FAILURE:
			return { ...state, fetchGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchGSTTypeDetailsResponse: null };
		/** ***************** FETCH GST TYPE DETAILS END *********************** */

		/** ***************** DELETE GST TYPE DETAILS START *********************** */
		case GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_SUCCESS:
			return { ...state, deleteGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_FAILURE:
			return { ...state, deleteGSTTypeDetailsResponse: action.payload };

		case GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteGSTTypeDetailsResponse: null };
		/** ***************** DELETE GST TYPE DETAILS END *********************** */

		default:
			return state;
	}
};
export default gstTypeReducer;
